import { CommonModule } from "@angular/common";
import { Component, inject, Input, OnInit } from "@angular/core";
import { AbstractControl, ControlContainer, FormArray, FormGroup, FormGroupDirective, 
          ReactiveFormsModule, Validators } from "@angular/forms";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatTimepickerModule } from "@angular/material/timepicker";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { MatIconModule } from "@angular/material/icon";
import { AppointmentTimeMatcher } from "../../../shared/other/touched-form-error-state-matcher";
import { TripRequestType } from "../../../dashboard/models/trip-request-models";
import { TripRequestFormFactory } from "../../shared/trip-request-form.factory";

@Component({
  selector: 'app-mobile-appointment',
  standalone: true,
  imports: [
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatDatepickerModule,
    MatTimepickerModule,
    ReactiveFormsModule,
    MatIconModule,
  ],
  viewProviders: [{ provide: ControlContainer, useExisting: FormGroupDirective }],
  templateUrl: './mobile-view.appointment.component.html',
  styleUrl: './mobile-view.appointment.component.scss',
})

export class MobileViewAppointmentComponent implements OnInit {
  @Input() tripType: string = ''; 
  private postTripRequestFormDir = inject(FormGroupDirective);
  private tripRequestFormFactory = inject(TripRequestFormFactory);
  tripRequest!: FormGroup;
  appointmentDatesFr!: FormArray;
  maxDate: Date | null = null;
  minDate: Date | null = null;
  matcher = new AppointmentTimeMatcher();


    
  ngOnInit(): void {
    if (this.tripType === TripRequestType.Post) {
      this.maxDate = new Date();
      this.minDate = new Date();
      this.minDate.setDate(this.maxDate.getDate() - 60);
    }
    else {
      this.minDate = new Date();
    }
    this.tripRequest = this.postTripRequestFormDir.form.get("tripRequest") as FormGroup;
    this.appointmentDatesFr = this.tripRequest.get("tripAppointments") as FormArray;

  }

  addAppointment() {
    if (this.tripType === TripRequestType.Post) {
      if (!this.tripRequest.get('isSameDriver')?.value) {
        const appointmentFg = this.tripRequestFormFactory.getPostTripAppointmentFg();
        appointmentFg.get('driverId')?.addValidators(Validators.required);
        this.appointmentDatesFr.push(appointmentFg);
      }
      else {
        this.appointmentDatesFr.push(this.tripRequestFormFactory.getPostTripAppointmentFg());
      }
    }
    else {
      this.appointmentDatesFr.push(this.tripRequestFormFactory.getPreTripAppointmentFg());
    }
  }

  removeAppointment(index: number) {
    if (this.appointmentDatesFr.length > 1) {
      this.appointmentDatesFr.removeAt(index);
    }
  }

  hasError(controlName: string, errorName: string): boolean {
    const control: AbstractControl | null = this.tripRequest.get(`${controlName}`);
    return !!control && control.hasError(errorName) && (control.dirty || control.touched);
  }

}